import Api from "./ApiNode";
import PhpApi from "./Api";

export default {
  getGRNList(payload, config) {
    let getContainer = Api().post("cont-alloc/get-all-grn", payload, config);
    return getContainer;
  },
  upsertContainerAllocation(payload) {
    let getContainer = Api().post("cont-alloc", payload);
    return getContainer;
  },
  getContainerAllocationList(payload, config) {
    let getContainer = Api().post("cont-alloc/get-cont-alloc", payload, config);
    return getContainer;
  },
  getSingleContainerAllocation(payload) {
    let getContainer = Api().get(`cont-alloc/${payload}`);
    return getContainer;
  },
  getAllLockPannelList(payload, config) {
    let AllClientUserList = Api().post("lock-pannel", payload, config);
    return AllClientUserList;
  },
  setRevieweStatus(payload) {
    let getReviewedData = Api().post("lock-pannel/review", payload);
    return getReviewedData;
  },
  saveNewBookingResp(payload) {
    let getReviewedData = Api().post("enq-pricing", payload);
    return getReviewedData;
  },
  updateBRFBookingStatus(payload) {
    let getBRFBookingData = Api().post(
      "enq-pricing/remove-revoke-brf-booking",
      payload,
    );
    return getBRFBookingData;
  },
  getBrfBookingLog(payload) {
    let getBRFBookingData = Api().post(
      "enq-pricing/get-brf-booking-log",
      payload,
    );
    return getBRFBookingData;
  },
  getBookingRespVessel(payload, config) {
    let getSingleBookingResp = Api().post(
      `enq-pricing/get-brf-vessel`,
      payload,
      config,
    );
    return getSingleBookingResp;
  },
  getBookingRespVesselJobProfitLoss(payload, config) {
    let getSingleBookingResp = Api().post(
      `enq-pricing/get-brf-vessel-job-pl`,
      payload,
      config,
    );
    return getSingleBookingResp;
  },
  // Profit & Loss (Node) - POST with JSON body
  getProfitLoss(payload = {}, config = {}) {
    return Api().post(`profit-loss/list`, payload, config);
  },
  getVehiclePerformanceMapConfig(config = {}) {
    return Api().get(`vehicle-performance/mapbox-config`, config);
  },
  getVehiclePerformanceDashboardData(config = {}) {
    return Api().get(`vehicle-performance/dashboard-data`, config);
  },
  getBookingRespEditor(payload, config) {
    let getSingleBookingResp = Api().post(
      `enq-pricing/get-brf-editor-list`,
      payload,
      config,
    );
    return getSingleBookingResp;
  },
  updateBRCMWithLogging(payload) {
    let getSingleBookingResp = Api().post(
      `enq-pricing/upsert-brf-editor-log`,
      payload,
    );
    return getSingleBookingResp;
  },
  updateMultipleBRCMWithLogging(payload) {
    let getSingleBookingResp = Api().post(
      `enq-pricing/upsert-multi-brf-editor-log`,
      payload,
    );
    return getSingleBookingResp;
  },
  getBRCMWithLogging(payload) {
    let getSingleBookingResp = Api().post(
      `enq-pricing/get-brf-editor-log`,
      payload,
    );
    return getSingleBookingResp;
  },
  getSingleNewBookingResp(BookingID) {
    let getSingleBookingResp = Api().get(`enq-pricing/${BookingID}`);
    return getSingleBookingResp;
  },
  getAllNewBookingRespList(payload, config) {
    let AllClientUserList = Api().post("enq-pricing/all", payload, config);
    return AllClientUserList;
  },

  getContractList(payload, config) {
    let queryString = new URLSearchParams(payload).toString();
    let AllClientUserList = Api().get(`contract?${queryString}`, config);
    return AllClientUserList;
  },
  getContractVesselList(payload, config) {
    let queryString = new URLSearchParams(payload).toString();
    let AllClientUserList = Api().get(
      `contract/contarct-vessel-list?${queryString}`,
      config,
    );
    return AllClientUserList;
  },
  saveContract(payload) {
    let getAllSavedContract = Api().post(`contract/upsert`, payload);
    return getAllSavedContract;
  },
  saveContractVessel(payload) {
    let getAllSavedContract = Api().post(`contract/upsert-vessel`, payload);
    return getAllSavedContract;
  },
  getAllContractDashList(payload, config) {
    let AllCommonJobList = Api().post(
      "contract/contract-dash",
      payload,
      config,
    );
    return AllCommonJobList;
  },
  getContractMainDash(payload, config) {
    let getReviewedData = Api().post(
      "lock-pannel/contract-dash",
      payload,
      config,
    );
    return getReviewedData;
  },
  getAllContractVesselDashList(payload, config) {
    let AllCommonJobList = Api().post(
      "contract/contract-vessel-wise-dash",
      payload,
      config,
    );
    return AllCommonJobList;
  },
  getAgentCMSDashList(payload, config) {
    let AllCommonJobList = Api().post(
      "lock-pannel/get-agent-cms-dash",
      payload,
      config,
    );
    return AllCommonJobList;
  },
  getAgentCMSConDashList(payload, config) {
    let AllCommonJobList = Api().post(
      "lock-pannel/get-agent-cms-cons-dash",
      payload,
      config,
    );
    return AllCommonJobList;
  },
  upsertAgentCMSDash(payload) {
    let AllCommonJobList = Api().post(
      "lock-pannel/upsert-agent-cms-dash",
      payload,
    );
    return AllCommonJobList;
  },

  getAllNotBillContainerDash(payload, config) {
    let AllCommonJobList = Api().post(
      "lock-pannel/get-not-bill-container-dash",
      payload,
      config,
    );
    return AllCommonJobList;
  },
  getAllUlipEchallanList(payload) {
    let getAllUlipList = PhpApi().post(
      "Api_Transport/getVehicleChallanData.php",
      payload,
    );
    return getAllUlipList;
  },
  getAllBilllingJobDash(payload, config) {
    let AllCommonJobList = Api().post(
      "get-common-job/get-bill-job-list",
      payload,
      config,
    );
    return AllCommonJobList;
  },
  getAssignmentSplitMergeData(payload, config) {
    let assignmentSplitMergeData = Api().post(
      "get-common-job/get-assignment-split-merge-move",
      payload,
      config,
    );
    return assignmentSplitMergeData;
  },
  getAllExpInvHeadList(payload, config) {
    let queryString = new URLSearchParams(payload).toString();
    let AllHeadList = Api().get(`inv-exp-head?${queryString}`, config);
    return AllHeadList;
  },
  saveExpInvHead(payload) {
    let AllHeadList = Api().post(`inv-exp-head`, payload);
    return AllHeadList;
  },
  importLedger(payload) {
    let getImportData = Api().post(`inv-exp-head/import-ledger`, payload);
    return getImportData;
  },

  getAllConsoleBookingList(payload, config) {
    let queryString = new URLSearchParams(payload).toString();
    let AllCBList = Api().get(`console-booking?${queryString}`, config);
    return AllCBList;
  },

  checkNotProceedConsoleBookingJob(payload) {
    return Api().post("console-booking/not-proceed-job", payload);
  },

  sendConsoleBookingApprovalRequest(payload) {
    return Api().post("console-booking/send-approval-request", payload);
  },

  getDelayReasons() {
    return Api().get("console-booking/delay-reasons");
  },

  addDelayReason(payload) {
    return Api().post("console-booking/delay-reasons", payload);
  },

  downloadClientZip(payload) {
    let AllHeadList = Api().get(`client/download/${payload}`, {
      responseType: "blob",
    });
    return AllHeadList;
  },

  invoiceHead(payload) {
    let queryString = new URLSearchParams(payload).toString();
    let AllHeadList = Api().get(`invoice?${queryString}`);
    return AllHeadList;
  },
  invoiceHeadItem(payload) {
    let queryString = new URLSearchParams(payload).toString();
    let AllHeadList = Api().get(`invoice/inv-item?${queryString}`);
    return AllHeadList;
  },
  expenseHead(payload) {
    let queryString = new URLSearchParams(payload).toString();
    let AllHeadList = Api().get(`expense?${queryString}`);
    return AllHeadList;
  },
  expenseHeadItem(payload) {
    let queryString = new URLSearchParams(payload).toString();
    let AllHeadList = Api().get(`expense/exp-item?${queryString}`);
    return AllHeadList;
  },

  getAllFailedPrealertList(payload, config) {
    let AllCommonJobList = Api().post(
      "get-common-job/get-failed-prealert",
      payload,
      config,
    );
    return AllCommonJobList;
  },

  getAllSalesJobList(payload, config) {
    let AllCommonJobList = Api().post(
      "get-common-job/all-ms-job",
      payload,
      config,
    );
    return AllCommonJobList;
  },

  getAllPaymentAccountList(payload, config) {
    const queryParams = new URLSearchParams(payload).toString();
    // let AllCommonJobList = Api().get(`sline-account?${queryParams}`, payload, config);
    let AllCommonJobList = Api().post("sline-account/get", payload, config);
    return AllCommonJobList;
  },
  upsertPaymentAccountList(payload, config) {
    let AllCommonJobList = Api().post("sline-account", payload, config);
    return AllCommonJobList;
  },

  getAllPaymentPLanningJobList(payload, config) {
    let AllCommonJobList = Api().post(
      "get-common-job/all-inv-payment-job",
      payload,
      config,
    );
    return AllCommonJobList;
  },

  getAllPaymentRequestList(payload, config) {
    let AllCommonJobList = Api().post(
      "get-common-job/all-sline-requset-final",
      payload,
      config,
    );
    return AllCommonJobList;
  },

  downloadAllPaymentRequestList(payload, config) {
    let AllCommonJobList = Api().post(
      "get-common-job/download-sline-requset-final",
      payload,
      config,
    );
    return AllCommonJobList;
  },
  downloadAssignmentZipNode(payload) {
    const queryParams = new URLSearchParams(payload).toString();
    return Api().get(`get-common-job/download-assignment-zip?${queryParams}`, {
      responseType: "blob",
    });
  },
  getUserInfo(payload) {
    let AllCommonJobList = Api().post(
      "get-common-job/get-allowed-payment-tabs",
      payload,
    );
    return AllCommonJobList;
  },
  bulkPaymentSortPlaning(payload, config) {
    let AllCommonJobList = Api().post(
      "get-common-job/bulk-inv-sortlistpayment",
      payload,
      config,
    );
    return AllCommonJobList;
  },

  SlineRequestFinalize(payload, config) {
    let AllCommonJobList = Api().post(
      "get-common-job/bulk-inv-requestsline",
      payload,
      config,
    );
    return AllCommonJobList;
  },

  getAllBulkPaymentJobList(payload, config) {
    let AllCommonJobList = Api().post(
      "get-common-job/all-payment-job",
      payload,
      config,
    );
    return AllCommonJobList;
  },

  getAllPaymentLogList(payload, config) {
    let AllCommonJobList = Api().post(
      "get-common-job/all-payment-log-job",
      payload,
      config,
    );
    return AllCommonJobList;
  },

  bulkPaymentJob(payload, config) {
    let AllCommonJobList = Api().post(
      "get-common-job/bulk-payment",
      payload,
      config,
    );
    return AllCommonJobList;
  },
  bulkPaymentCorrectionJob(payload, config) {
    let AllCommonJobList = Api().post(
      "get-common-job/bulk-payment-correction",
      payload,
      config,
    );
    return AllCommonJobList;
  },
  excelBulkPaymentJob(payload, config) {
    let AllCommonJobList = Api().post(
      "get-common-job/excel-bulk-payment",
      payload,
      config,
    );
    return AllCommonJobList;
  },

  getAllCommonJobList(payload, config) {
    let AllCommonJobList = Api().post("get-common-job", payload, config);
    return AllCommonJobList;
  },
  verifyContainer(payload, config) {
    let getContainer = Api().post(
      "get-common-job/verify-cont",
      payload,
      config,
    );
    return getContainer;
  },
  /** Same route as verifyContainer; body `onlyAssignmentJobType: true` returns jobType / hasFF without heavy container checks */
  verifyContainerAssignmentJobType(payload, config) {
    const body = Object.assign({}, payload || {}, {
      onlyAssignmentJobType: true,
    });
    return Api().post("get-common-job/verify-cont", body, config);
  },
  getJobContainerList(payload, config) {
    let getContainer = Api().post("get-common-job/cont-list", payload, config);
    return getContainer;
  },
  updateJobContainer(payload, config) {
    let getContainer = Api().post(
      "get-common-job/cont-sob-update",
      payload,
      config,
    );
    return getContainer;
  },
  resetSlineSubscriptionFlow(payload, config) {
    let getContainer = Api().post(
      "get-common-job/reset-sline-flow",
      payload,
      config,
    );
    return getContainer;
  },
  getJobPaymentFlow(payload, config) {
    let getContainer = Api().post(
      "get-common-job/get-payments",
      payload,
      config,
    );
    return getContainer;
  },
  getJobConsolidationContainerList(payload, config) {
    let getContainer = Api().post(
      "get-common-job/cont-consolidation-list",
      payload,
      config,
    );
    return getContainer;
  },
  updateConsolidationJobContainer(payload, config) {
    let getContainer = Api().post(
      "get-common-job/cont-consolidation-update",
      payload,
      config,
    );
    return getContainer;
  },
  getAllUnUsedBookingList(payload, config) {
    let AllCommonJobList = Api().post(
      "console-booking/unused",
      payload,
      config,
    );
    return AllCommonJobList;
  },
  updateUnUsedBookingStatus(payload, config) {
    let AllCommonJobList = Api().post("console-booking/cb-status", payload);
    return AllCommonJobList;
  },
  getBookingApprovalLogList(payload, config) {
    let AllApprovalLogList = Api().post(
      "console-booking/get-cb-approval-log",
      payload,
      config,
    );
    return AllApprovalLogList;
  },
  upsertShipper(payload) {
    let shipperDet = Api().post("client/upsertshipper", payload);
    return shipperDet;
  },
  getAllOutstandingList(payload, config) {
    const queryParams = new URLSearchParams(payload).toString();
    let AllCommonJobList = Api().get(
      `ledger-outstanding?${queryParams}`,
      config,
    );
    return AllCommonJobList;
  },

  getAllClientOutstandingList(payload, config) {
    let AllCommonJobList = Api().post(
      `ledger-outstanding/get-client-outstanding`,
      payload,
      config,
    );
    return AllCommonJobList;
  },

  getAllFailedExpenseList(payload, config) {
    let AllCommonJobList = Api().post(
      `get-common-job/get-failed-expense`,
      payload,
      config,
    );
    return AllCommonJobList;
  },

  getFailedAdditionalTask(payload, config) {
    let AllCommonJobList = Api().post(
      `get-common-job/get-failed-additional-task`,
      payload,
      config,
    );
    return AllCommonJobList;
  },

  getFailedManifestTask(payload, config) {
    let AllCommonJobList = Api().post(
      `get-common-job/get-failed-manifest`,
      payload,
      config,
    );
    return AllCommonJobList;
  },

  getAllAirList(payload, config) {
    const queryParams = new URLSearchParams(payload).toString();
    let AllCommonJobList = Api().get(`air?${queryParams}`, config);
    return AllCommonJobList;
  },

  getSingleAir(payload, config) {
    let AllCommonJobList = Api().get(`air/${payload}`, config);
    return AllCommonJobList;
  },

  saveAir(payload, config) {
    let AllCommonJobList = Api().post(`air`, payload);
    return AllCommonJobList;
  },
  getNatureOfExpense(payload, config) {
    let queryString = new URLSearchParams(payload).toString();
    let getBRFBookingData = Api().post(
      `nature-of-expense/get-nature-of-expense?${queryString}`,
      payload,
      config,
    );
    return getBRFBookingData;
  },
  getJobNatureOfExpense(payload) {
    let queryString = new URLSearchParams(payload).toString();
    let getBRFBookingData = Api().post(
      `nature-of-expense/get-job-noe`,
      payload,
    );
    return getBRFBookingData;
  },
  upsertNatureOfExpense(payload) {
    let getBRFBookingData = Api().post("nature-of-expense", payload);
    return getBRFBookingData;
  },
  lockUnLockStatus(payload) {
    return PhpApi().post("Api_Common/locknnlockStatus.php", payload);
  },
};



// WEBPACK FOOTER //
// ./src/services/NodeLockPannelService.js